export const USD1_SWAP_SUBGRAPH_URL = 'https://graph.api.movachain.com/subgraphs/name/usd1swap/usd1-stake-main';

export const USD1_SWAP_POOLS_QUERY = `
  query QueryPools {
    pools {
      rewardToken
      rewardTokenLogoURL
    }
  }
`;

export type Usd1SwapPool = {
  rewardToken: string;
  rewardTokenLogoURL: string | null;
};

type Usd1SwapPoolsResponse = {
  data?: {
    pools?: Array<Usd1SwapPool>;
  };
};

export async function fetchUsd1SwapPools(): Promise<Array<Usd1SwapPool>> {
  const response = await fetch(USD1_SWAP_SUBGRAPH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query: USD1_SWAP_POOLS_QUERY }),
  });

  if (!response.ok) {
    throw new Error('Failed to fetch USD1 swap pools');
  }

  const json = await response.json() as Usd1SwapPoolsResponse;
  return json.data?.pools ?? [];
}

export function findUsd1SwapPoolToken(pools: Array<Usd1SwapPool>, tokenAddress: string): Usd1SwapPool | null {
  const normalizedAddress = tokenAddress.toLowerCase();

  return pools.find((pool) => pool.rewardToken?.toLowerCase() === normalizedAddress) ?? null;
}
